import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { PrimaryButton } from "./Buttons";
import { Grid } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  mt100: {
    marginTop: 100,
  },
  mt20: {
    marginTop: 20,
  },
}));
const Fallback = ({ error }) => {
  const classes = useStyles();
  const handleReload = () => {
    window.location.reload(false);
  };

  return (
    <>
      <Grid container direction="row" className={classes.mt100}>
        <Grid item xs={false} sm={3} />
        <Grid item xs={12} sm={6}>
          <Typography variant="h1" color="primary" align="center">
            insmeal
          </Typography>
        </Grid>
        <Grid item xs={false} sm={3} />
        <Grid item xs={false} sm={3} />
        <Grid item xs={12} sm={6} className={classes.mt20}>
          <Typography variant="h5" color="primary" align="center">
            {error ? error : "App broke down😥😥!!! Please reload!"}
          </Typography>
        </Grid>
        <Grid item xs={false} sm={3} />
        <Grid item xs={false} sm={3} />
        <Grid item xs={12} sm={6} className={classes.mt20}>
          <PrimaryButton
            fullWidth
            type="warning"
            size="large"
            handleClick={handleReload}
          >
            Reload
          </PrimaryButton>
        </Grid>
        <Grid item xs={false} sm={3} />
      </Grid>
    </>
  );
};

export default Fallback;
